import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import Popup from "reactjs-popup";
import * as yup from "yup";
import AuthApi from "../../apis/auth.api";
import UserApi from "../../apis/user.api";
import AppAlert from "../../components/AppAlert";
import OutlineSubBtn from "../../components/buttons/OutlineSubBtn";
import SolidBlueBtn from "../../components/buttons/SolidBlueBtn";
import AppInput from "../../components/controls/AppInput";
import Spinner from "../../components/spinner/Spinner";
import { RESULT_CODE } from "../../constants/AppConstants";
import { ROUTE_PATHS } from "../../constants/Router";
import useAuth from "../../hooks/useAuth";
import AppUtils from "../../utils";
import formatPhoneNumber from "../../utils/formatPhoneNumber";

const PhoneNumberModal = function ({
  openModal,
  setOpenModal,
  defaultPhoneNumber,
}) {
  const [openIncorrectNumber, setOpenIncorrectNumber] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { ceoInfo } = useAuth();

  const schema = yup.object().shape({
    phone: yup.string().required(),
  });
  const { control, handleSubmit, setValue } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = async (data) => {
    const removedDashPhoneNumber = AppUtils.replaceDash(data.phone);
    setOpenIncorrectNumber(false);

    if (
      removedDashPhoneNumber.length >= 9 &&
      removedDashPhoneNumber.length <= 11 &&
      removedDashPhoneNumber.startsWith("010")
    ) {
      if (ceoInfo?.shop_idx) {
        try {
          setLoading(true);
          const res = await UserApi.sendOtp({
            shopIdx: ceoInfo?.shop_idx,
            phone: removedDashPhoneNumber,
          });

          if (res.data && res.data.result_code !== RESULT_CODE.NO_RESULT) {
            navigate(ROUTE_PATHS.VerifyCode, {
              state: {
                data,
                phoneNumber: data.phone,
                shopIdx: ceoInfo?.shop_idx,
                type: "edit-phone-number",
              },
            });
          }
        } finally {
          setLoading(false);
        }
      }
    } else {
      setOpenIncorrectNumber(true);
    }
  };

  useEffect(() => {
    if (defaultPhoneNumber) {
      setValue("phone", defaultPhoneNumber);
    }
  }, [defaultPhoneNumber]);

  useEffect(() => {
    setOpenIncorrectNumber(false);
  },[openModal])

  return (
    <Popup
      // trigger={<button className="button"> Open Modal </button>}
      open={openModal}
      closeOnDocumentClick
      onClose={() => {
        setOpenModal && setOpenModal(false);
      }}
      modal
      nested
      position="bottom center"
      contentStyle={{
        position: "fixed",
        bottom: "0",
        borderRadius: "24px 24px 0 0",
      }}
    >
      <div className="modal modal-change-phone">
        <div className="content">
          <div>
            <form onSubmit={handleSubmit(onSubmit)}>
              <AppInput
                control={control}
                name="phone"
                placeholder="대표자 휴대폰 번호를 입력해 주세요."
                label="새 휴대폰 번호"
                maximum={11}
                isKoreaPhoneNumber
                type="number"
                className="w-100 mb-6"
                hideValue
              />
             
              <div className="phone-change-wrapper">
                <button type="button" className={`outline-sub-btn py-3 w-full h-[56px]`} onClick={()=>setOpenModal(false)}>
                  취소
                </button>
                <SolidBlueBtn
                  disabled={loading}
                  className="w-full flex items-center justify-center h-[56px]"
                  type="submit"
                >
                  <Spinner isLoading={loading} />
                  인증번호 받기
                </SolidBlueBtn>
              </div>
              </form>
          </div>
          <AppAlert
            title="휴대폰 번호가 올바르지 않아요."
            desc="번호를 다시 한번 확인해 주세요."
            open={openIncorrectNumber}
            onOk={() => setOpenIncorrectNumber(false)}
            okText="확인"
            type="error"
          />
        </div>
      </div>
    </Popup>
  );
};
export default PhoneNumberModal;
